import { render } from "./ProfileTab.vue?vue&type=template&id=0f2bc32c&scoped=true"
import script from "./ProfileTab.vue?vue&type=script&lang=js"
export * from "./ProfileTab.vue?vue&type=script&lang=js"

import "./ProfileTab.vue?vue&type=style&index=0&id=0f2bc32c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2bc32c"],['__file',"src/views/AccountReceivable/ProfileTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f2bc32c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f2bc32c', __exports__)) {
    api.reload('0f2bc32c', __exports__)
  }
  
  module.hot.accept("./ProfileTab.vue?vue&type=template&id=0f2bc32c&scoped=true", () => {
    api.rerender('0f2bc32c', render)
  })

}


export default __exports__